/** 绑房补录申请 — /resident/api/resident/houseBindApply */
import http from "../../http";

const BASE = "/resident/api/resident/houseBindApply";

const bindApply = {
  /** 分页列表（可按 applyStatus 筛选） */
  selectPage(r) {
    return http.get(`${BASE}/page`, r);
  },
  /** 各状态数量（Tab 角标） */
  statusCount(r) {
    return http.get(`${BASE}/statusCount`, r);
  },
  /** 详情 */
  detail(r) {
    return http.get(`${BASE}/detail`, r);
  },
  /** 办结（不选房） */
  done(r) {
    return http.payload(`${BASE}/done`, r);
  },
  /** 驳回 */
  reject(r) {
    return http.payload(`${BASE}/reject`, r);
  },
  /** 选房绑定并办结 */
  bind(r) {
    return http.payload(`${BASE}/bind`, r);
  },
};

export default bindApply;
